import React from 'react';
import { Box, Typography, Button, Modal as MuiModal, Backdrop } from '@mui/material';

// We're using MUI's Modal directly to ensure proper centering
const TeamDeleteCardModal = ({ open, onClose, onConfirm }) => {
    return (
        <MuiModal
            open={open}
            onClose={onClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 500,
                    maxWidth: '90%',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 8,
                }}
            >
                <Typography
                    sx={{
                        fontWeight: 'normal',
                        fontSize: '1rem',
                        textAlign: 'left',
                        mb: 3
                    }}
                >
                    Are you sure you want to delete this card? This action cannot be undone.
                </Typography>

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: 2
                }}>
                    <Button
                        variant="outlined"
                        onClick={onClose}
                        sx={{
                            backgroundColor: 'white',
                            color: '#4f4f4f',
                            borderRadius: '20px',
                            border: '1px solid #e3e3e3',
                            textTransform: 'none',
                            padding: '8px 24px',
                            minWidth: '100px'
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        onClick={onConfirm}
                        sx={{
                            backgroundColor: '#000',
                            color: '#fff',
                            borderRadius: '20px',
                            textTransform: 'none',
                            padding: '8px 24px',
                            minWidth: '100px'
                        }}
                    >
                        Yes, delete
                    </Button>
                </Box>
            </Box>
        </MuiModal>
    );
};

export default TeamDeleteCardModal;